<template>
    <section>
        <modal v-if="showModal" @close="showModal = false"
            v-on:keydown.esc="showModal = false"
            :title="modalTitle"
            :sizeOfModal="'small'"
            :showElement="showModal">
            <template v-slot:modalContent>
                <p>Selecciona una cobradora y una acción para sus créditos.</p>
                <form class="ui form" @submit.prevent>
                    <div class="field required">
                        <label>Cobradora</label>
                        <sui-dropdown
                            fluid
                            placeholder="Selecciona una cobradora..."
                            selection
                            search
                            :options="collectorOptions"
                            v-model="record.selectedCollectorId"
                        />
                    </div>
                    <label><strong>Acción</strong></label>
                    <sui-form-fields fields="two">
                        <sui-form-field>
                            <sui-checkbox
                                radio
                                label="Reasignar créditos activos a la nueva cobradora"
                                name="creditsAction"
                                value="reassign"
                                v-model="record.creditsAction"
                            />
                        </sui-form-field>
                        <sui-form-field>
                            <sui-checkbox
                                radio
                                label="Mantener créditos activos con la cobradora actual"
                                name="creditsAction"
                                value="keep"
                                v-model="record.creditsAction"
                            />
                        </sui-form-field>
                    </sui-form-fields>
                </form>
            </template>
            <template v-slot:modalFooter>
                <div class="actions">
                    <sui-button
                        primary
                        :disabled="!record.selectedCollectorId || !record.creditsAction"
                        @click="confirm()"
                    >
                        {{ promoter && promoter.supervision ? 'Actualizar' : 'Asignar' }}
                    </sui-button>
                    <sui-button @click="confirm(true)">Cerrar</sui-button>
                </div>
            </template>
        </modal>
    </section>
</template>

<script>
import Modal from '@/components/Helpers/Modal.vue'

export default {
    name: 'AssignCollectorModal',
    components: { Modal },
    props: ['showModal', 'promoter', 'collectorOptions'],

    data () {
        return {
            record: { selectedCollectorId: null, creditsAction: null, cancel: false }
        }
    },

    computed: {
        modalTitle () {
            const action = this.promoter && this.promoter.supervision ? 'Cambiar' : 'Asignar'
            const name = this.promoter ? this.promoter.fullName : ''
            return `${action} Cobradora de ${name}`
        }
    },

    watch: {
        showModal (val) {
            if (val) {
                const currentCollectorId = this.promoter && this.promoter.supervision && this.promoter.supervision.supervisor
                    ? this.promoter.supervision.supervisor.id
                    : null
                this.record = { selectedCollectorId: currentCollectorId, creditsAction: null, cancel: false }
            }
        }
    },

    methods: {
        confirm (cancel = false) {
            if (cancel) {
                this.record.cancel = true
                this.$emit('modalResponse', this.record)
                return
            }

            const currentCollectorId = this.promoter && this.promoter.supervision && this.promoter.supervision.supervisor
                ? this.promoter.supervision.supervisor.id
                : null

            if (this.record.selectedCollectorId === currentCollectorId) {
                this.$swal({
                    icon: 'info',
                    title: 'Sin cambios',
                    text: 'Esa cobradora ya está asignada a esta promotora. Selecciona una diferente para continuar.',
                    timer: 3000,
                    position: 'top',
                    showConfirmButton: false
                })
                return
            }

            this.record.cancel = false
            this.$emit('modalResponse', this.record)
        }
    }
}
</script>
